import { RowAction } from '@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table.types';

type Condition<T> = boolean | ((item: T) => boolean) | undefined;
type RowCondition = boolean | ((item: Record<string, unknown>) => boolean) | undefined;
export class RowActionVm<T> implements RowAction {
    constructor(
        public id: string,
        public label: string,
        hiddenCondition: Condition<T>,
        disabledCondition: Condition<T>
    ) {
        this.hiddenCondition = this.toRowActionCondition(hiddenCondition);
        this.disabledCondition = this.toRowActionCondition(disabledCondition);
    }

    public hiddenCondition: RowCondition;

    public disabledCondition: RowCondition;

    /**
     * Narrows the condition function to match the expected type in RowAction.
     */
    private toRowActionCondition<T>(
        condition?: boolean | ((item: T) => boolean)
    ): boolean | ((item: Record<string, unknown>) => boolean) | undefined {
        if (typeof condition === 'function') {
            return (item: Record<string, unknown>) => condition(item as T);
        }
        return condition;
    }
}
